import { DesktopAudioArtifactRef, DesktopAudioArtifactSnapshot } from "@/modules/electron/types";

type DesktopAudioArtifactLike = Pick<DesktopAudioArtifactRef, "durationMs">;

/**
 * Desktop artifact refs use the recording id as their stable lookup key.
 */
export const getAudioRecordingIdFromDesktopAudioArtifactRef = ({
  artifactRef,
}: {
  artifactRef: DesktopAudioArtifactRef;
}): string => {
  return artifactRef.key;
};

export const isDesktopAudioArtifactMissingOrEmpty = ({
  artifactRef,
}: {
  artifactRef: DesktopAudioArtifactRef | null;
}): boolean => {
  if (artifactRef === null) {
    return true;
  }

  return artifactRef.sizeBytes === 0;
};

export const getDesktopAudioArtifactDurationMs = ({
  artifact,
}: {
  artifact: DesktopAudioArtifactLike | DesktopAudioArtifactSnapshot | null;
}): number | null => {
  if (!artifact) {
    return null;
  }

  return artifact.durationMs ?? null;
};
